import Vue from 'vue'
import ClickOutside from 'vue-click-outside'
import { isTouchDevice } from 'lib/util'
import select from 'select-dom'
import on from 'dom-event'

const BREAK_POINT = 768
const TOOLTIP_WIDTH = 245
const MOBILE_RANGE_POSITION_RIGHT = 108

Vue.component('tooltip', {
  name: 'tooltip',
  props: [
    'offset'
  ],
  data: function () {
    return {
      isActive: false,
      position: 'default'
    }
  },
  methods: {
    showTooltip (show, event) {
      const tooltipContent = select('.tooltip__content', event.currentTarget)
      this.isActive = !this.isActive
      if (tooltipContent) {
        if (this.isActive) {
          tooltipContent.tabIndex = -1
          tooltipContent.focus()
        } else {
          tooltipContent.removeAttribute('tabIndex')
          event.currentTarget.focus()
        }
        on(tooltipContent, 'keydown', (e) => {
          if (e.keyCode === 9 || e.keyCode === 27 || e.keyCode === 9) {
            this.isActive = false
            if (e.shiftKey) {
              event.currentTarget.focus()
            }
          }
        })
      }
      if (!event.currentTarget.classList.contains('tooltip--product-form')) {
        this.setPosition(event)
      }
    },
    setPosition (event) {
      const windowWidth = document.body.clientWidth
      const positionRight = event.clientX + TOOLTIP_WIDTH
      const positionMobileRight = TOOLTIP_WIDTH - event.clientX
      if (positionRight >= windowWidth) {
        if (windowWidth > BREAK_POINT) {
          this.position = 'to-top'
        } else {
          if (positionMobileRight < MOBILE_RANGE_POSITION_RIGHT) {
            this.position = 'to-top-mobile'
          }

          if (positionMobileRight <= 32) {
            this.position = 'to-right-mobile'
          }

          if (positionMobileRight >= 160) {
            this.position = 'to-left-mobile'
          }
        }
      }
    },
    hideTooltip () {
      this.isActive = false
    }
  },
  directives: {
    ClickOutside
  },
  template: `
  <button class="tooltip tooltip--default relative"
    type="button"
    ref="tooltip"
    v-on:click="showTooltip(!isActive, $event)"
    v-click-outside="hideTooltip"
    :class="{'is-active' : isActive}">
    <i class="tooltip__icon f aic jcc">
      <svg class="w1" viewBox="0 0 245.334 245.334" aria-hidden="true">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-info" x="0" y="0"></use>
      </svg>
    </i>
    <transition name="fade-in-down">
      <p
        class="tooltip__content p2"
        :class="'offset--' + position"
      >
        <span class="tooltip__content-inner">
          <slot name="contents" />
        </span>
      </p>
    </transition>
  </button>`
})
